import React, { Component } from 'react'

import SoloLogo from '../assets/solologo.svg'

class WindowSpinner extends Component {
  render () {
    return (
      <div className="window-spinner">
        <div className='circle'>
          <img src={SoloLogo} alt='anomaleet' />
        </div>
      </div>
    )
  }
}

export default WindowSpinner
